// ⚠️ 重要：本特定商取引法に基づく表記は、本番デプロイ前に弁護士または行政書士のレビューを推奨します。
//
// TODO: 本番デプロイ前に以下の環境変数を本番値に設定してください
//   - VITE_LEGAL_BUSINESS_NAME       … 販売事業者名
//   - VITE_LEGAL_RESPONSIBLE_NAME    … 運営統括責任者氏名
//   - VITE_SUPPORT_EMAIL             … サポートメールアドレス
//   - VITE_INVOICE_REGISTRATION_NO   … 適格請求書発行事業者登録番号(インボイス番号)
//
// 注: このプロジェクトはVite (TanStack Start) を使用しているため、
//     フロントエンドに公開する環境変数は VITE_ プレフィックスが必要です
//     (Next.js の NEXT_PUBLIC_ ではありません)。
//
// 個人事業主の場合は、適格請求書発行事業者登録(インボイス番号)を別途取得してください。

export const TOKUSHOHO_LAST_UPDATED = "2026年5月1日";

export const TOKUSHOHO_PREAMBLE =
  "特定商取引法第11条に基づき、KAGEMの販売事業者情報および取引条件について以下のとおり表記します。";

/** 環境変数を読み、未設定なら fallback を返す。 */
function envOr(key: string, fallback: string): string {
  // import.meta.env は ビルド時にインライン展開される
  const v = (import.meta.env as Record<string, string | undefined>)[key];
  return v && v.trim().length > 0 ? v : fallback;
}

export interface LegalEntryLink {
  label: string;
  href: string;
  external?: boolean;
}

export interface LegalEntry {
  label: string;
  /** 文字列、または評価時に文字列を返す関数。 */
  value: string | (() => string);
  /** 補助的なリンク（料金ページや利用規約など） */
  links?: LegalEntryLink[];
  /** 注釈（小さく表示） */
  note?: string;
}

export const TOKUSHOHO_ENTRIES: LegalEntry[] = [
  {
    label: "販売事業者",
    value: () => envOr("VITE_LEGAL_BUSINESS_NAME", "高橋隆"),
  },
  {
    label: "運営統括責任者",
    value: () => envOr("VITE_LEGAL_RESPONSIBLE_NAME", "高橋隆"),
  },
  {
    label: "所在地",
    value: "〒150-0001 東京都渋谷区神宮前六丁目23番4号 桑野ビル2階",
  },
  {
    label: "連絡先",
    value: () => envOr("VITE_SUPPORT_EMAIL", "support@kagem.ai"),
  },
  {
    label: "電話番号",
    value: "メールにてお問い合わせください。請求あり次第開示します",
  },
  {
    label: "受付時間",
    value: "平日10:00〜18:00(土日祝日を除く)",
  },
  {
    label: "販売価格",
    value: "各料金プランページおよびクレジット購入ページに記載のとおり(すべて税込)",
    links: [
      { label: "料金プラン", href: "/billing" },
      { label: "クレジット購入", href: "/credits-shop" },
    ],
  },
  {
    label: "商品代金以外の必要料金",
    value: "インターネット通信料はお客様のご負担となります。",
  },
  {
    label: "支払方法",
    value: "クレジットカード決済(Stripe Inc. を通じて処理されます)",
  },
  {
    label: "支払時期",
    value:
      "購入時に即時決済されます。サブスクリプションプランは、以降毎月自動更新されます。",
  },
  {
    label: "商品の引渡し時期",
    value: "決済完了後、即時にアカウントへ反映されます。",
  },
  {
    label: "返品・キャンセル",
    value:
      "デジタルコンテンツの性質上、原則として返品・返金は承っておりません。詳細は利用規約をご参照ください。",
    links: [{ label: "利用規約", href: "/terms" }],
  },
  {
    label: "サブスクリプションの解約",
    value:
      "月契約：設定画面からいつでも解約可能。次回課金日まで引き続きご利用いただけ、日割り精算は行いません。\n年契約（12ヶ月縛りの月払い）：解約リクエストはいつでも可能ですが、12ヶ月目の課金完了までは請求が継続し、その終了日をもって自動的に解約されます。",
    links: [{ label: "設定", href: "/settings" }],
  },
  {
    label: "クレジットの有効期限",
    value:
      "買い切り型クレジットは購入日から6ヶ月。サブスクリプションで毎月付与されるクレジットは当該月内のみ有効で、翌月以降への繰越はできません。",
  },
  {
    label: "動作環境",
    value: "Google Chrome / Safari / Microsoft Edge / Mozilla Firefox の最新版",
  },
];
